import React from 'react';
import { useTranslation } from 'react-i18next';
import Form from './Form';

const ApproverList = ({
  authorizedSignatories = [],
  approverData = [],
  index,
  user,
  usersmain = [],
  accessState = {},
  getUser,
  locationState = [],
  submit,
}) => {
  const { t } = useTranslation('common');
  const UK = t('access.UNITEDKINGDOM');
  const onlyUKAccess = !!accessState.onlyUKAccess;
  const approverCount = accessState.isAPACAndUKAccess && (user?.access?.length > 1)
    ? 2
    : Math.max(1, parseInt(approverData[index] || 1, 10));

  return authorizedSignatories.map((approverDetails, id) => {
    const firstSelfEnroll = user.selfenroll === '1';
    const accessLength = user?.access?.length || 0;
    const showUK =
      firstSelfEnroll &&
      ((accessLength === 1 && user.access[0].country === UK) ||
        (accessLength === 0) ||
        onlyUKAccess);

    const showAPAC = firstSelfEnroll && !showUK && !!accessState.isAPACAndUKAccess;

    if (id > approverCount - 1) return null;

    return (
      <React.Fragment key={`Approver-${id}`}>
        {showUK && <h3 className="pad-2-b">{t('access.authapproverinfouk')}</h3>}
        {showAPAC && <h3 className="pad-2-b">{t('access.authapproverinfoapac')}</h3>}
        <Form
          key={`ApproverForm-${id}`}
          country={user.country}
          getUser={getUser}
          user={locationState[3] === "prev" ? authorizedSignatories[id] : user}
          AccessCountryUser={usersmain[index]}
          index={index}
          approverCount={approverCount}
          approverDetails={approverDetails}
          id={id}
          prev={locationState[3]}
          length={approverData[index]}
          modifyUser={locationState[4]}
          indexId={id}
          submit={submit}
          showOnlyUKTCCheckbox={showUK}
          showOnlyAPACCheckbox={showAPAC}
          onlyUKAccess={onlyUKAccess}
        />
      </React.Fragment>
    );
  });
};

export default ApproverList;
